module.exports = __webpack_public_path__ + "fonts/Noto_Sans_TC-400-127.c600a4d.woff2";